import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CardHeader, IconButton, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { CartButton } from 'pages/CustomerBookingCreate/components/PageHeader/CartButton';

import { STEP_CART_ENABLED, STEP_SERVICE_COST, STEP_SERVICE_DETAILS, STEP_SERVICE_PACKAGES } from 'pages/CustomerBookingCreate/constants';
import { bookingState, stepState } from 'pages/CustomerBookingCreate/state';
import { Suspense, useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { getServices } from 'services/service.service';

const useStyles = makeStyles(theme => ({
}));
const ServiceCostScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);

  const [servicePackages, setServicePackages] = useState([]);

  const [booking, setBooking] = useRecoilState(bookingState);
  const fetchServices = useCallback(
    async () => {
      const params = {
        longitude: booking?.location?.longitude,
        latitude: booking?.location?.latitude,
        // city: booking?.location?.city
      }
      const res = await getServices({
        ...params,
        city: null
      })
      setServicePackages(res)
    },
    [booking?.location],
  );

  useEffect(
    () => {
      fetchServices()
    }, []
  );
  return (
    <>
      <PageHeader
        backStep={STEP_SERVICE_DETAILS}
        currentStep={STEP_SERVICE_COST}
        title={"COST BREAKDOWN"}
        subheader={"---"}
        isCartEnabled
        callToActionButton={
          <Suspense fallback={<Button variant="contained" disabled fullWidth>Loading...</Button>}>
            <CartButton
              isCartEnabled={STEP_CART_ENABLED.includes(step)}
            />
          </Suspense>
        }
      >
        <>servicecost</>
      </PageHeader>
    </>
  )


}

export { ServiceCostScreen };
